import { SubjectIdContext } from '@surveycake/react-logic-engine';
import { SubjectContainer } from 'app/pages/Survey/Subject/elements';
import React, { memo } from 'react';
import { subjectMap } from './types';

export interface SubjectProps {
  id: number;
}

function Subject({ id }: SubjectProps) {
  return (
    <SubjectIdContext.Provider value={id}>
      <SubjectContainer>
        {type => {
          const SubjectComponent = subjectMap[type];
          return SubjectComponent && <SubjectComponent />;
        }}
      </SubjectContainer>
    </SubjectIdContext.Provider>
  );
}

export default memo(Subject, (prev, next) => prev.id === next.id);
